import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { lockComponents } from '../../../../../configs/WidgetConfig';
import {
  isNotLoginOrExpired,
  removeSpecialChar,
} from '../../../../helpers/Common';
import EventEmitter, {
  SHOW_GUEST_POPUP,
} from '../../../../helpers/EventEmitter';
import Layout from '../../../../helpers/Layout';
import { setDragPopup } from '../../../reducer';
import { addHeadlineCode, REDUCER_NAME } from '../notifi-maque/reducer';
import SearchPopup from './SearchPopup';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';

class Search extends Component {
  state = {
    value: '',
    currentCode: null,
    isShowList: false,
  };
  inputRef = React.createRef();

  componentDidMount() {
    setTimeout(() => {
      Layout.layout.on('componentCreated', this.onComponentCreated);
    }, 0);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { value, currentCode } = this.state;
    const { organizations, coveredWarrants, derivatives } = this.props;
    const isChangeCoveredWarrant =
      coveredWarrants.length && !prevProps.coveredWarrants.length;
    const isChangeDerivative =
      derivatives.length && !prevProps.derivatives.length;
    const isChangeOrganizations =
      organizations.length && !prevProps.organizations.length;

    if (
      (isChangeCoveredWarrant || isChangeDerivative || isChangeOrganizations) &&
      !currentCode &&
      value
    ) {
      this.setState({
        currentCode: this.getCode(value),
      });
    }
  }

  onComponentCreated = () => {
    const { isShowList } = this.state;
    if (isShowList) {
      this.setState({
        isShowList: false,
        value: '',
      });
      this.inputRef.current.blur();
    }
  };

  onInputChange = e => {
    this.setState({
      value: e.target.value,
      currentCode: this.getCode(e.target.value),
    });
  };

  findCode = (value, list) => {
    const pattern = new RegExp(`^${removeSpecialChar(value)}`, 'i');

    let code = list.find(item =>
      pattern.test(removeSpecialChar(item.displayCode)),
    );
    if (!code) {
      code = list.find(item => pattern.test(removeSpecialChar(item.codeName)));
    }

    return code;
  };

  getTicker = value => {
    const { organizations } = this.props;
    return this.findCode(value, organizations);
  };

  getCoveredWarrant = value => {
    const { coveredWarrants } = this.props;
    return this.findCode(value, coveredWarrants);
  };

  getDerivative = value => {
    const { derivatives } = this.props;
    return this.findCode(value, derivatives);
  };

  getCode = value => {
    const ticker = this.getTicker(value);
    if (ticker) {
      return ticker;
    }
    const coveredWarrant = this.getCoveredWarrant(value);
    if (coveredWarrant) {
      return coveredWarrant;
    }
    const derivative = this.getDerivative(value);
    if (derivative) {
      return derivative;
    }

    return null;
  };

  onInputFocus = () => {
    this.setState({
      isShowList: true,
      currentCode: this.getCode(this.state.value),
    });
  };

  hideList = () => {
    this.setState({
      isShowList: false,
    });
  };

  addToHeadline = ticker => {
    const { addHeadlineCode, headlineCodes } = this.props;
    if (headlineCodes.every(item => item.code !== ticker.ticker)) {
      addHeadlineCode(ticker);
      this.resetState();
    }
  };

  openWidget = component => {
    const { currentCode } = this.state;
    const { setDragPopup, user } = this.props;
    this.inputRef.current.blur();
    if (isNotLoginOrExpired(user) && lockComponents[component]) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }

    if (typeof component === 'object') {
      setDragPopup({
        isShow: true,
        componentName: component.component,
        content: I18n.t(`layout.quickAccess.${component.componentDescription}`),
        organCode: null,
        props: component.props,
      });
      this.resetState();
      return;
    }
    setDragPopup({
      isShow: true,
      componentName: component,
      content: I18n.t(`layout.quickAccess.${component}`),
      organCode: currentCode.code,
    });
    this.resetState();
  };

  resetState = () => {
    this.setState({
      isShowList: false,
      value: '',
      currentCode: this.getCode(''),
    });
  };

  render() {
    const { value, isShowList, currentCode } = this.state;

    return (
      <div className="search-box-top float-left">
        <div className="search-tool-box">
          <input
            ref={this.inputRef}
            onFocus={this.onInputFocus}
            onChange={this.onInputChange}
            value={value}
            type="search"
            placeholder={I18n.t('common.searchAdd.search')}
          />
          <button type="button">
            <i className="icon-search" />
          </button>
        </div>
        <div style={{ display: isShowList ? 'block' : 'none' }}>
          <SearchPopup
            isShowList={isShowList}
            keyword={value}
            addToHeadline={this.addToHeadline}
            openWidget={this.openWidget}
            currentCode={currentCode}
            inputRef={this.inputRef}
            hideList={this.hideList}
          />
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  organizations: PropTypes.array.isRequired,
  derivatives: PropTypes.array.isRequired,
  coveredWarrants: PropTypes.array.isRequired,
  setDragPopup: PropTypes.func.isRequired,
  addHeadlineCode: PropTypes.func.isRequired,
  headlineCodes: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  i18n: state.i18n,
  organizations: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  derivatives: state[COMMON_REDUCER_NAME].listDerivative,
  coveredWarrants: state[COMMON_REDUCER_NAME].listCoveredWarrant,
  headlineCodes: state[REDUCER_NAME].headlineCodes,
  user: state.userInfo,
});

const mapDispatchToProps = {
  setDragPopup,
  addHeadlineCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);
